import { createReducer } from 'redux-act';
import Immutable from 'seamless-immutable';
import _ from 'lodash';
import WorkspaceActions from './workspace-actions';
import WorkspaceModel from './workspace-model';

import experienceWorkspaces from './workspaces';
import workspaceBaseConfig from './workspaces/base-config';

const initialState = Immutable({
  activeWorkspace:     WorkspaceModel.create(WorkspaceModel.create(workspaceBaseConfig)),
  byExperienceSubtype: _.mapValues(experienceWorkspaces, (workspaceConfig) => {
    return WorkspaceModel.create(workspaceConfig);
  }),
  isScreenEditorVisible: false,
});

const reducer = createReducer((on) => {
  on(WorkspaceActions.changeExperienceType, (state, { experience }) => {
    const workspace = WorkspaceModel.mergeExperience(
      //Nextgen experiences having different workspace models for each subtype refs, while macro experiences using the default workspace for now
      state.byExperienceSubtype[experience.subtypeRef.id] || WorkspaceModel.create(workspaceBaseConfig),
      experience
    );
    return state.set('activeWorkspace', workspace);
  });
  on(WorkspaceActions.decorateWorkspaceWithUser, (state, { user }) => {
    const workspace = WorkspaceModel.decorateWorkspaceWithUser(state.activeWorkspace, user);
    return state.set('activeWorkspace', workspace);
  });
}, initialState);

export default reducer;
